// src/pages/admin/billing/AdminBillingSettingsPage.js
import React from 'react';
import AdminLayout from '../../../components/admin/AdminLayout';
import SettingsForm from '../../../components/admin/billing/SettingsForm';
import pb from '../../../lib/pocketbase';

function AdminBillingSettingsPage() {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [settings, setSettings] = React.useState(null);
  const [settingsId, setSettingsId] = React.useState(null);

  const mockSettings = {
    company_name: 'InfoColab',
    company_address: '123 Avenue de la Mécanique',
    company_postal_code: '75001',
    company_city: 'Paris',
    company_phone: '01.23.45.67.89',
    company_email: 'contact@example.com',
    company_website: 'https://example.com',
    siret: '12345678901234',
    siren: '123456789',
    tva_number: 'FR12345678901',
    rcs: 'Paris B 123 456 789',
    default_tax_rate: '20',
    quote_validity_days: '30',
    quote_footer: 'Devis valable 30 jours.',
    invoice_footer: 'Paiement à 30 jours.',
    bank_name: 'Crédit Mutuel',
    bank_iban: 'FR76 1234 5678 9012 3456 7890 123',
    bank_bic: 'CMCIFR2A',
    quote_counter: '1001',
    invoice_counter: '2001',
    quote_prefix: 'DEV',
    invoice_prefix: 'FACT',
    invoice_payment_terms: '30',
    business_hours: {
      monday: { open: '08:00', close: '18:00' },
      tuesday: { open: '08:00', close: '18:00' },
      wednesday: { open: '08:00', close: '18:00' },
      thursday: { open: '08:00', close: '18:00' },
      friday: { open: '08:00', close: '18:00' },
      saturday: { open: '08:00', close: '12:00' },
      sunday: { closed: true }
    }
  };

  const fetchSettings = React.useCallback(async () => {
    setError('');
    try {
      const res = await pb.collection('settings').getList(1, 1, { sort: '-created' });
      const s = res?.items?.[0];
      if (s) { setSettings(s); setSettingsId(s.id); }
      else { setSettings(null); setSettingsId(null); }
    } catch (e) {
      setError(e?.message || 'Erreur chargement paramètres');
      setSettings(null); setSettingsId(null);
    }
  }, []);

  React.useEffect(() => { fetchSettings(); }, [fetchSettings]);

  const handleSubmit = async (submitData, logoFile, signatureFile) => {
    setLoading(true);
    setError('');
    try {
      const data = new FormData();
      Object.keys(submitData).forEach(k => data.append(k, submitData[k]));
      if (logoFile) data.append('logo', logoFile);
      if (signatureFile) data.append('signature', signatureFile);

      let saved;
      if (settingsId) saved = await pb.collection('settings').update(settingsId, data);
      else saved = await pb.collection('settings').create(data);

      setSettings(saved); setSettingsId(saved.id);
      setOpen(false);
    } catch (e) {
      setError(e?.message || "Erreur d'enregistrement des paramètres");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title="">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ marginTop: 0 }}>Paramètres de l'entreprise</h3>
        <button
          className="btn-primary"
          onClick={()=>setOpen(true)}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            padding: '10px 14px', borderRadius: 10,
            background: 'linear-gradient(135deg, var(--admin-accent), rgba(79,70,229,0.85))',
            border: '1px solid rgba(79,70,229,0.6)',
            boxShadow: '0 6px 18px rgba(79,70,229,0.35)',
            color: 'white'
          }}
        >
          <span style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:24, height:24, borderRadius:999, background:'rgba(255,255,255,0.18)', border:'1px solid rgba(255,255,255,0.25)' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
          </span>
          <span>Modifier les paramètres</span>
        </button>
      </div>
      <style>{`
        .btn-primary:hover { transform: translateY(-1px); filter: brightness(1.04); }
        .btn-primary:active { transform: translateY(0); filter: brightness(0.98); }
        .settings-card { border:1px solid var(--admin-border); border-radius:10px; padding:12px; background: var(--admin-panel); transition: box-shadow .2s ease, border-color .2s ease, transform .2s ease; }
        .settings-card:hover { box-shadow: 0 8px 20px rgba(0,0,0,0.18); border-color: rgba(79,70,229,0.35); transform: translateY(-1px); }
        .settings-card-header { display:flex; align-items:center; justify-content:space-between; gap:8px; font-weight:700; padding-bottom:8px; margin-bottom:8px; border-bottom:1px solid var(--admin-border); }
        .settings-card-header h4 { margin:0; font-size:1rem; font-weight:700; }
        .settings-grid { display:grid; grid-template-columns: repeat(3, minmax(280px, 1fr)); gap:12px; justify-content:center; }
        @media (max-width: 1200px) { .settings-grid { grid-template-columns: repeat(2, minmax(280px, 1fr)); } }
        @media (max-width: 700px) { .settings-grid { grid-template-columns: 1fr; } }
        .settings-info { display:grid; gap:6px; }
        .info-item { display:flex; align-items:center; justify-content:space-between; gap:12px; }
        .info-label { color: var(--admin-muted); font-weight:600; }
        .info-value { text-align:right; font-weight:500; }
      `}</style>
      {error && <div style={{ color:'#ef4444', marginBottom:8 }}>{error}</div>}
      

      {/* Résumé des paramètres (6 cartes) */}
      <div className="card" style={{ marginTop: 12, padding: 16 }}>
        <div className="settings-grid">
          {/* Informations de l'entreprise */}
          <div className="settings-card">
            <div className="settings-card-header">
              <h4>Informations de l'entreprise</h4>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
            </div>
            <div className="settings-info">
              <div className="info-item"><span className="info-label">Nom :</span> <span className="info-value">{(settings?.company_name ?? mockSettings.company_name) || 'Non défini'}</span></div>
              <div className="info-item"><span className="info-label">Email :</span> <span className="info-value">{(settings?.company_email ?? mockSettings.company_email) || 'Non défini'}</span></div>
              <div className="info-item"><span className="info-label">Téléphone :</span> <span className="info-value">{(settings?.company_phone ?? mockSettings.company_phone) || 'Non défini'}</span></div>
              <div className="info-item"><span className="info-label">Adresse :</span> <span className="info-value">{(() => {
                const a = settings?.company_address ?? mockSettings.company_address;
                const cp = settings?.company_postal_code ?? mockSettings.company_postal_code;
                const v = settings?.company_city ?? mockSettings.company_city;
                if (!a && !cp && !v) return 'Non définie';
                return `${a||''}${cp?`, ${cp}`:''}${v?` ${v}`:''}`.trim();
              })()}</span></div>
            </div>
          </div>
          {/* Informations légales */}
          <div className="settings-card">
            <div className="settings-card-header">
              <h4>Informations légales</h4>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/></svg>
            </div>
            <div className="settings-info">
              <div className="info-item"><span className="info-label">SIRET :</span> <span className="info-value">{(settings?.siret ?? mockSettings.siret) || 'Non défini'}</span></div>
              <div className="info-item"><span className="info-label">SIREN :</span> <span className="info-value">{(settings?.siren ?? mockSettings.siren) || 'Non défini'}</span></div>
              <div className="info-item"><span className="info-label">TVA :</span> <span className="info-value">{(settings?.tva_number ?? mockSettings.tva_number) || 'Non défini'}</span></div>
              <div className="info-item"><span className="info-label">RCS :</span> <span className="info-value">{(settings?.rcs ?? mockSettings.rcs) || 'Non défini'}</span></div>
            </div>
          </div>

          {/* Paramètres financiers */}
          <div className="settings-card">
            <div className="settings-card-header">
              <h4>Paramètres financiers</h4>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"/></svg>
            </div>
            <div className="settings-info">
              <div className="info-item"><span className="info-label">TVA par défaut :</span> <span className="info-value">{(settings?.default_tax_rate ?? mockSettings.default_tax_rate) ?? '0'}%</span></div>
              <div className="info-item"><span className="info-label">Validité devis :</span> <span className="info-value">{(settings?.quote_validity_days ?? mockSettings.quote_validity_days) ?? '0'} jours</span></div>
              <div className="info-item"><span className="info-label">Délai paiement :</span> <span className="info-value">{(settings?.invoice_payment_terms ?? mockSettings.invoice_payment_terms) ?? '0'} jours</span></div>
            </div>
          </div>
          {/* Numérotation */}
          <div className="settings-card">
            <div className="settings-card-header">
              <h4>Numérotation</h4>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M2,17H22V19H2V17M1.15,12.65L4,11.47L4.85,12.65L2,13.83L1.15,12.65M6.5,10L10.5,10V12L6.5,12V10M6.5,6L20.5,6V8L6.5,8V6M2,4L4,4V6L2,6V4Z"/></svg>
            </div>
            <div className="settings-info">
              <div className="info-item"><span className="info-label">Prochain devis :</span> <span className="info-value">{(settings?.quote_prefix ?? mockSettings.quote_prefix) || 'DEV'}-{String(settings?.quote_counter ?? mockSettings.quote_counter ?? 1).padStart(4,'0')}</span></div>
              <div className="info-item"><span className="info-label">Prochaine facture :</span> <span className="info-value">{(settings?.invoice_prefix ?? mockSettings.invoice_prefix) || 'FACT'}-{String(settings?.invoice_counter ?? mockSettings.invoice_counter ?? 1).padStart(4,'0')}</span></div>
            </div>
          </div>
          {/* Logo et signature */}
          <div className="settings-card">
            <div className="settings-card-header">
              <h4>Logo et signature</h4>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19M19,19H5V5H19V19M13.96,12.29L11.21,15.83L9.25,13.47L6.5,17H17.5L13.96,12.29Z"/></svg>
            </div>
            <div style={{ display:'grid', gap:6 }}>
              <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                <span style={{ fontWeight:500 }}>Logo:</span>
                <span>
                  {settings?.logo ? (
                    <img alt="Logo" src={`${pb?.baseUrl || 'https://infocolab.infocolab.online'}/api/files/settings/${settings.id}/${settings.logo}`} style={{ maxWidth:120, maxHeight:50, borderRadius:6, border:'1px solid var(--admin-border)' }} />
                  ) : (
                    <span style={{ color:'var(--admin-muted)' }}>Non défini</span>
                  )}
                </span>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                <span style={{ fontWeight:500 }}>Signature:</span>
                <span>
                  {settings?.signature ? (
                    <img alt="Signature" src={`${pb?.baseUrl || 'https://infocolab.infocolab.online'}/api/files/settings/${settings.id}/${settings.signature}`} style={{ maxWidth:160, maxHeight:60, borderRadius:6, border:'1px solid var(--admin-border)' }} />
                  ) : (
                    <span style={{ color:'var(--admin-muted)' }}>Non définie</span>
                  )}
                </span>
              </div>
            </div>
          </div>

          {/* Informations bancaires */}
          <div className="settings-card">
            <div className="settings-card-header">
              <h4>Informations bancaires</h4>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M11,8H13V16H11V14H9V12H11V8M9,10V12H7V10H9M15,12V14H13V12H15M15,8V10H13V8H15M17,6H7A2,2 0 0,0 5,8V16A2,2 0 0,0 7,18H17A2,2 0 0,0 19,16V8A2,2 0 0,0 17,6Z"/></svg>
            </div>
            <div className="settings-info">
              <div className="info-item"><span className="info-label">Banque :</span> <span className="info-value">{(settings?.bank_name ?? mockSettings.bank_name) || 'Non définie'}</span></div>
              <div className="info-item"><span className="info-label">IBAN :</span> <span className="info-value" style={{ fontFamily:'monospace' }}>{(settings?.bank_iban ?? mockSettings.bank_iban) || 'Non défini'}</span></div>
              <div className="info-item"><span className="info-label">BIC :</span> <span className="info-value" style={{ fontFamily:'monospace' }}>{(settings?.bank_bic ?? mockSettings.bank_bic) || 'Non défini'}</span></div>
            </div>
          </div>
        </div>
        {/* Bouton unique en haut (déjà présent) */}
      </div>

      {open && (
        <SettingsForm
          settings={settings || mockSettings}
          onSubmit={handleSubmit}
          onCancel={() => setOpen(false)}
          loading={loading}
        />
      )}
    </AdminLayout>
  );
}

export default AdminBillingSettingsPage;
